import { attachErrorHandler } from '@sentry/vue'
import * as Sentry from '@sentry/browser'
import { captureConsoleIntegration, rewriteFramesIntegration } from '@sentry/browser'
import { contains, flat, isObject, logAble } from '@/utils/tools'

export function attachAppToSentry(app) {
  attachErrorHandler(app, { logErrors: true })
  return Sentry
}

export function initializeSentry({
  dsn = 'develop',
  release = 'develop',
  environment = 'develop',
}) {
  Sentry.init({
    dsn,
    integrations: [
      Sentry.browserTracingIntegration(),
      captureConsoleIntegration({
        levels: ['error'],
      }),
      rewriteFramesIntegration({
        // root path that will be appended to the basename of the current frame's url
        root: '',
        // function that takes the frame, applies a transformation, and returns it
        iteratee(frame) {
          return { ...frame, filename: frame.filename.split('?')[0] }
        },
      }),
    ],
    environment,
    release,
    tracesSampleRate: 1.0,
    beforeSend(event) {
      if (event.user) {
        // Don't send user's name or email
        delete event.user.email
        delete event.user.name
      }
      return event
    },
  })
  if (typeof currentUser !== 'undefined') Sentry.setUser(currentUser)
  return Sentry
}

const sentryProxyLogger = {
  apply(target, thisArg, argArray) {
    if (argArray.length > 1) {
      const obj = argArray[1]
      if (isObject(obj) && contains(obj, 'query')) {
        Sentry.addBreadcrumb({
          category: 'graphql',
          message: 'graphql query',
          level: 'info',
          data: {
            query: flat(obj)
              .definitions.map((def) => def?.name?.value ?? 'unnamed query')
              .join(' | '),
            variables: logAble(obj.variables),
          },
        })
      }
    }
    // eslint-disable-next-line prefer-rest-params
    return Reflect.apply(target, thisArg, argArray)
  },
}

export function apolloListener(ApolloClient) {
  // eslint-disable-next-line no-param-reassign
  ApolloClient.queryManager.fetchQuery = new Proxy(
    ApolloClient.queryManager.fetchQuery,
    sentryProxyLogger,
  )
  return ApolloClient
}
